<template>
  <ipub-model title="Change Password"
              width="400px"
              :visable="isVisable"
              @confirm="confirm"
              @cancel="cancel">
    <div class="ipub-p4 mar-b-20">The password needs to have at least 8 digital and no longer than 20 digital. It has to contain both letters and numbers.</div>
    <ipub-form ref="profile-change-password-form"
               :model="params"
               :rules="rules">
      <ipub-form-item prop="rawPassword"
                      label="Original  Password">
        <ipub-input password
                    v-model.trim="params.rawPassword"
                    placeholder="Original  Password" />
      </ipub-form-item>
      <ipub-form-item prop="password"
                      label="New Password">
        <ipub-input password
                    v-model.trim="params.password"
                    placeholder="New Password" />
      </ipub-form-item>
      <ipub-form-item prop="repassword"
                      label="Confirm Password">
        <ipub-input password
                    v-model.trim="params.repassword"
                    placeholder="Confirm Password" />
      </ipub-form-item>
    </ipub-form>
  </ipub-model>
</template>

<script>
import { mapGetters } from 'vuex'
import user from '../../../api/user'
export default {
  props: {
    isVisable: {
      type: Boolean,
      default: false
    },
    inputData: {
      type: Object,
      default () {
        return {}
      }
    }
  },
  data () {
    return {
      params: {},
      rules: {}
    }
  },
  computed: {
    ...mapGetters({
      language: 'getLanguage',
    })
  },
  watch: {
    isVisable (val) {
      if (!val) {
        this.params = {}
      }
    },
  },
  mounted () {
    this.getRules()
  },
  methods: {
    async confirm () {
      const flag = this.$refs['profile-change-password-form'].validate()
      if (flag) {
        if (this.params.repassword !== this.params.password) {
          this.$message.error({
            title: 'Error',
            content: `The two passwords are inconsistent`
          })
          return
        }
        await user.password(this.params)
        this.$emit('confirm')
      }
    },
    cancel () {
      this.$emit('cancel')
    },
    getRules () {
      this.rules = {
        rawPassword: [
          {
            required: true,
            message: 'Password' + this.LANGUAGE[this.language].noEmpty
          },
          {
            min: 6,
            message: `Password length must not be less than 6 digits`
          },
          {
            max: 20,
            message: `Password length must not be more than 20 digits`
          },
          {
            pattern: /(?!^\d+$)(?!^[A-Za-z]+$)(?!^[^A-Za-z0-9]+$)(?!^.*[\u4E00-\u9FA5].*$)^\S{6,20}$/,
            message: `Must be composed of letters, numbers, and symbols.`
          }
        ],
        password: [
          {
            required: true,
            message: 'Password' + this.LANGUAGE[this.language].noEmpty
          },
          {
            min: 6,
            message: `Password length must not be less than 6 digits`
          },
          {
            max: 20,
            message: `Password length must not be more than 20 digits`
          },
          {
            pattern: /(?!^\d+$)(?!^[A-Za-z]+$)(?!^[^A-Za-z0-9]+$)(?!^.*[\u4E00-\u9FA5].*$)^\S{6,20}$/,
            message: `Must be composed of letters, numbers, and symbols.`
          }
        ],
        repassword: [
          {
            required: true,
            message: 'Password' + this.LANGUAGE[this.language].noEmpty
          },
          {
            min: 6,
            message: `Password length must not be less than 6 digits`
          },
          {
            max: 20,
            message: `Password length must not be more than 20 digits`
          },
          {
            pattern: /(?!^\d+$)(?!^[A-Za-z]+$)(?!^[^A-Za-z0-9]+$)(?!^.*[\u4E00-\u9FA5].*$)^\S{6,20}$/,
            message: `Must be composed of letters, numbers, and symbols.`
          }
        ],
      }
    }
  }
}
</script>
